import { ImageFragment } from "../../fragments/image";
import { KnowledgeBaseBaseFragment } from "../../fragments/knowledge-base";
import { gql } from "@apollo/client";

export const QUERY_KNOWLEDGE_BASE = gql`
  query knowledgeBase($slug: [String]) {
    knowledgeBases: knowledgeBases_connection(
      pagination: { limit: 1 }
      sort: "publicationDate:desc"
      filters: { slug: { in: $slug }, publishedAt: { notNull: true } }
    ) {
      data {
        id
        documentId
        publicationDate
        attributes {
          title
          slug
          duration
          briefDescription
          knowledgeBaseType {
            data {
              id
              documentId
              attributes {
                type
              }
            }
          }
          subHeader
          cover {
            data {
              ...ImageFragment
            }
          }
          DefaultContentTemplate {
            __typename
            ... on ComponentCommonH3 {
              text
            }
            ... on ComponentCommonMedia {
              media {
                data {
                  attributes {
                    url
                    alternativeText
                  }
                }
              }
            }
            ... on ComponentCommonTitle {
              title
            }

            ... on ComponentCommonAuthorDetailed {
              authors: authors_connection {
                data {
                  attributes {
                    name
                    role
                    bio
                    avatar {
                      data {
                        ...ImageFragment
                      }
                    }
                  }
                }
              }
            }

            ... on ComponentKnowledgeBaseKnowledgeBaseRelated {
              knowledgeBases: knowledgeBases_connection(
                filters: { publishedAt: { notNull: true } }
              ) {
                data {
                  attributes {
                    ...KnowledgeBaseBaseFragment
                  }
                }
              }
            }

            ... on ComponentCommonDivider {
              id
            }

            ... on ComponentCommonEmbedded {
              link
              provider
            }

            ... on ComponentCommonTextEditor {
              markdownText
            }

            ... on ComponentCommonEmbedded {
              link
              provider
            }

            ... on ComponentCommonBullet {
              item {
                text
              }
            }

            ... on ComponentCommonQuote {
              quote
            }

            ... on ComponentCommonFaqComponent {
              faq {
                title
                description
              }
            }
            ... on ComponentCommonTags {
              id
            }
            ... on ComponentCommonRelatedContent {
              id
            }

            ... on ComponentCommonDownloadableContentList {
              list {
                title
                description
                content {
                  data {
                    attributes {
                      url
                    }
                  }
                }
              }
            }

            ... on ComponentCommonAudio {
              transcription
              audio {
                url
              }
            }

            ... on ComponentDefaultContentTemplateTimer {
              timerType: type
              timerAudio: audio {
                title
                prompt
                spokenGuidance {
                  data {
                    attributes {
                      name
                      url
                    }
                  }
                }
              }
              timerPrompt: prompt {
                title
                prompt
                durationInSeconds
              }
              timerVideo: video {
                videoTitle
                video {
                  data {
                    attributes {
                      name
                      url
                      height
                      width
                    }
                  }
                }
              }
              timerAudioLabels: audioLabels {
                title
                startExerciseButton
                thankYouTitle
                backDailyBubbleButton
                playButtonLabel
                pauseButtonLabel
                stopButtonLabel
                restartButtonLabel
                minutes {
                  id
                  minute
                }
              }
              timerPromptLabels: promptLabels {
                title
                backDailyBubbleButton
                startExerciseButton
                thankYouTitle
                playButtonLabel
                pauseButtonLabel
                stopButtonLabel
                restartButtonLabel
              }
              timerVideoLabels: videoLabels {
                title
                backDailyBubbleButton
                thankYouTitle
              }
            }
          }
        }
      }
    }
  }
  ${KnowledgeBaseBaseFragment}
  ${ImageFragment}
`;

export const QUERY_FETCH_KNOWLEDGE_BASE_PAGEABLE = gql`
  query fetchLatestKnowledgeBasePageable(
    $kinds: [String]
    $page: Int!
    $search: String
  ) {
    knowledgeBases: knowledgeBases_connection(
      pagination: { pageSize: 8, page: $page }
      sort: "publicationDate:desc"
      filters: {
        title: { containsi: $search }
        knowledgeBaseType: { type: { in: $kinds } }
        publishedAt: { notNull: true }
      }
    ) {
      data {
        id
        attributes {
          ...KnowledgeBaseBaseFragment
        }
      }
      meta {
        pagination {
          page
          pageCount
          total
        }
      }
    }
  }
  ${KnowledgeBaseBaseFragment}
  ${ImageFragment}
`;

export const QUERY_FETCH_LATEST_KNOWLEDGE_BASES = gql`
  query fetchLatestKnowledgeBase($slug: [String]) {
    knowledgeBases: knowledgeBases_connection(
      pagination: { limit: 2 }
      sort: "publicationDate:desc"
      filters: { slug: { notIn: $slug }, publishedAt: { notNull: true } }
    ) {
      data {
        id
        attributes {
          ...KnowledgeBaseBaseFragment
        }
      }
    }
  }
  ${KnowledgeBaseBaseFragment}
  ${ImageFragment}
`;

export const QUERY_KNOWLEDGE_BASE_TYPES = gql`
  query fetchKnowledgeBaseTypes {
    knowledgeBaseTypes {
      documentId
      type
    }
  }
`;

export const QUERY_KNOWLEDGE_BASE_TYPES_WITH_PUBLISHED_ITEMS = gql`
  query fetchKnowledgeBaseTypesWithPublishedItems {
    knowledgeBaseTypesWithPublishedItems {
      documentId
      type
    }
  }
`;

export const QUERY_FIND_LISTENING_TIME = gql`
  query findPodcastListeningTime($filters: PodcastListeningTimeFiltersInput) {
    podcastListeningTimes(filters: $filters) {
      documentId
      id
      listeningTime
      duration
    }
  }
`;
